import { Controller } from '@hotwired/stimulus';
import { patch } from '@rails/request.js';

export default class extends Controller {
  static targets = ['position'];
  static values = { url: String };

  submit() {
    const formData = new FormData();
    this.positionTargets.forEach((input) => {
      formData.append('positions[]', input.value);
    });

    patch(this.urlValue, {
      responseKind: 'turbo-stream',
      body: formData,
      credentials: 'same-origin',
    });
  }
}
